function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "73",
  height: "64",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "5.59%",
  y1: "14.2%",
  x2: "73%",
  y2: "68.54%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35ABAB",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#676E96",
  offset: "67%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C568F",
  offset: "89%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56488B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-26.42%",
  y1: "-26.42%",
  x2: "119.58%",
  y2: "119.58%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35ABAB",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#676E96",
  offset: "67%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C568F",
  offset: "89%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56488B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-8.18%",
  y1: "-8.18%",
  x2: "102.96%",
  y2: "102.96%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35ABAB",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#676E96",
  offset: "67%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C568F",
  offset: "89%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56488B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "linearGradient-4"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35ABAB",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#676E96",
  offset: "67%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C568F",
  offset: "89%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56488B",
  offset: "100%"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "graphic_spot_multimedia",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.72 0H1.28C.58 0 0 .58 0 1.3v50.4c0 .72.57 1.3 1.28 1.3H31V23h35V1.3c0-.72-.57-1.3-1.28-1.3zM3 3.75c0-.41.3-.75.67-.75h6.66c.37 0 .67.34.67.75v4.5c0 .41-.3.75-.67.75H3.67C3.3 9 3 8.66 3 8.25v-4.5zm0 41c0-.41.3-.75.67-.75h6.66c.37 0 .67.34.67.75v4.5c0 .41-.3.75-.67.75H3.67c-.37 0-.67-.34-.67-.75v-4.5zm13-41c0-.41.3-.75.67-.75h6.66c.37 0 .67.34.67.75v4.5c0 .41-.3.75-.67.75h-6.66c-.37 0-.67-.34-.67-.75v-4.5zm0 41c0-.41.3-.75.67-.75h6.66c.37 0 .67.34.67.75v4.5c0 .41-.3.75-.67.75h-6.66c-.37 0-.67-.34-.67-.75v-4.5zm13 0c0-.41.3-.75.67-.75H31v6h-1.33c-.37 0-.67-.34-.67-.75v-4.5zm0-41c0-.41.3-.75.67-.75h6.66c.37 0 .67.34.67.75v4.5c0 .41-.3.75-.67.75h-6.66c-.37 0-.67-.34-.67-.75v-4.5zm13 0c0-.41.3-.75.67-.75h6.66c.37 0 .67.34.67.75v4.5c0 .41-.3.75-.67.75h-6.66c-.37 0-.67-.34-.67-.75v-4.5zm13 0c0-.41.3-.75.67-.75h6.66c.37 0 .67.34.67.75v4.5c0 .41-.3.75-.67.75h-6.66c-.37 0-.67-.34-.67-.75v-4.5z",
  id: "Shape",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63 22.92H31V41l-27-.2a1 1 0 01-1-1V13a1 1 0 011-1h58a1 1 0 011 1v9.92z",
  id: "Path",
  fill: "#193138",
  opacity: ".2",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 27.15V41H4a1 1 0 01-1-1v-7.27c7.65-5.48 13.99-6.64 18.27-6.73 2.95-.05 6.9.34 9.73 1.15z",
  id: "Path",
  fill: "#193138",
  opacity: ".1",
  style: {
    mixBlendMode: "multiply"
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(31 22)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "url(#linearGradient-2)",
  x: "4",
  y: "4",
  width: "34",
  height: "34",
  rx: "1.28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 1.24v39.52C0 41.45.55 42 1.24 42h39.52c.69 0 1.24-.55 1.24-1.24V1.24C42 .55 41.45 0 40.76 0H1.24C.55 0 0 .55 0 1.24zM3.39 40C2.62 40 2 39.38 2 38.61V3.4C2 2.62 2.62 2 3.39 2H38.6c.77 0 1.39.62 1.39 1.39V38.6c0 .77-.62 1.39-1.39 1.39H3.4z",
  id: "Shape",
  fill: "url(#linearGradient-3)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "url(#linearGradient-4)",
  opacity: ".2",
  style: {
    mixBlendMode: "multiply"
  },
  cx: "29.5",
  cy: "11.5",
  r: "4.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 14L26.4 31.57 15.04 21.24 4 32.62v3.9c0 .71.57 1.3 1.28 1.3l31.44.18c.7 0 1.28-.58 1.28-1.3V14z",
  id: "Path",
  fill: "#193138",
  opacity: ".2",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  fill: "#193138",
  opacity: ".2",
  style: {
    mixBlendMode: "multiply"
  },
  d: "M16 21l18 17H21.02z"
})))));